import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import TeamViewMixin from 'flux/stores/TeamViewMixin';
import TeamViewActions from 'flux/actions/TeamViewActions';
import TeamActions from 'flux/actions/TeamActions';
import RealTimeActions from 'flux/actions/RealTimeActions';
import { fromJS } from 'immutable';

import LabelFormActions from 'flux/actions/LabelFormActions';
import LabelEditFormActions from 'flux/actions/LabelEditFormActions';
import LabelListActions from 'flux/actions/LabelListActions';

const onLabelCreated = LabelFormActions.create.completed;
const onLabelUpdated = LabelEditFormActions.update.completed;
const onLabelDeleted = LabelListActions.softDelete.completed;

/**
 * TeamViewStore
 *
 */
export default Reflux.createStore({
  listenables: [TeamViewActions, RealTimeActions, TeamActions],

  mixins: [BaseMixin, TeamViewMixin],

  init() {
    this.listenTo(onLabelCreated, 'onLabelCreated');
    this.listenTo(onLabelUpdated, 'onLabelUpdated');
    this.listenTo(onLabelDeleted, 'onLabelDeleted');
  },

  onSetTabTitle(title) {
    const next = this.getState().set('tabTitle', title);

    this.setStateAndTrigger(next);
  },

  onLabelCreated(team) {
    this.mergeStateAndTrigger(fromJS(team));
  },

  onLabelUpdated(team) {
    this.mergeStateAndTrigger(fromJS(team));
  },

  onLabelDeleted(team) {
    this.mergeStateAndTrigger(fromJS(team));
  },
  onPopulateForGuestCompleted(team) {
    this.setStateAndTrigger(fromJS(team));
  },
});
